export default __webpack_public_path__ + "static/bncff-mobile-2-dc148813523b7feed93aed4166e676f6.jpg";